import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import styled from '@emotion/styled';
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useRef } from 'react';
import { FilterWithoutDividerOption } from '../FilterChipSelect';

const StyledMenuItem = styled(MenuItem)`
    margin: 6px 8px;
    padding: 0 12px;
    border-radius: 8px;
    gap: 10px;
    align-items: center;

    &.Mui-selected {
        background-color: rgba(0, 0, 0, 0.04);

        :hover {
            background-color: rgba(0, 0, 0, 0.04);
        }
    }

    img svg {
        margin-left: -4px;
    }
`;

interface Props {
    selected: boolean;
    option: FilterWithoutDividerOption;
    onChange: (option: FilterWithoutDividerOption) => void;
}

export const SelectItem = ({ selected, option, onChange }: Props) => {
    const ref = useRef<HTMLLIElement>(null);

    useEffect(() => {
        if (selected && ref.current) {
            ref.current.scrollIntoView();
        }
    }, [selected]);

    const icon =
        option.icon && !option.skipListIcon ? (
            typeof option.icon === 'string' ? (
                <MaskedIcon src={option.icon} size="16px" />
            ) : (
                <>{option.icon}</>
            )
        ) : null;

    return (
        <StyledMenuItem ref={ref} key={option.value} value={option.value} onClick={() => onChange(option)} selected={selected}>
            {icon}
            {option.label}
        </StyledMenuItem>
    );
};
